// Guide article: reading progress, table-of-contents highlight, copy-link button, spec-table helpers.
(function () {
  var guide = document.querySelector('.kb-guide');
  if (!guide) return;
  var prose = guide.querySelector('.kb-prose');

  // Reading progress
  var bar = document.querySelector('[data-kb-progress]');
  // Table-of-contents highlight
  var links = Array.prototype.slice.call(guide.querySelectorAll('.kb-side .kb-toc a'));
  var targets = links.map(function (a) {
    return document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
  });

  var ticking = false;
  function update() {
    ticking = false;
    if (bar && prose) {
      var r = prose.getBoundingClientRect();
      var h = r.height - window.innerHeight;
      var p = h > 0 ? Math.min(1, Math.max(0, -r.top / h)) : 0;
      bar.style.width = (p * 100).toFixed(1) + '%';
    }
    if (links.length) {
      var current = 0;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i] && targets[i].getBoundingClientRect().top < window.innerHeight * 0.3) current = i;
      }
      links.forEach(function (a, i) {
        a.classList.toggle('is-active', i === current);
      });
    }
  }
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();

  // Close the mobile table of contents after a jump
  guide.querySelectorAll('.kb-toc-mobile a').forEach(function (a) {
    a.addEventListener('click', function () {
      a.closest('details').open = false;
    });
  });

  // Copy link
  var copy = guide.querySelector('[data-kb-copy]');
  if (copy) {
    copy.addEventListener('click', function () {
      var label = copy.querySelector('span');
      var original = label.textContent;
      var done = function () {
        label.textContent = copy.getAttribute('data-copied');
        setTimeout(function () {
          label.textContent = original;
        }, 1800);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(copy.getAttribute('data-kb-copy')).then(done, done);
      } else {
        done();
      }
    });
  }

  // Spec tables: right-align numbers, flag values over a limit, turn yes/no cells into chips
  var YES = ['yes', 'ja', 'oui', 'sì', 'si', 'sí', 'tak'];
  var NO = ['no', 'nein', 'non', 'nie'];
  guide.querySelectorAll('.kb-table table').forEach(function (table) {
    // Limits and cell values may use a decimal comma ("2,5" on German pages)
    var limitAttr = table.getAttribute('data-kb-limit') || '';
    var limit = parseFloat(limitAttr.replace(',', '.'));
    var col = parseInt(table.getAttribute('data-kb-col'), 10);
    var numericCols = {};
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (td, i) {
        var text = td.textContent.trim();
        var lower = text.toLowerCase();
        if (i > 0 && /^[<>~≈]?\s?\d/.test(text)) {
          td.classList.add('kb-num');
          numericCols[i] = true;
        }
        if (!isNaN(limit) && i + 1 === col && parseFloat(text.replace(',', '.')) > limit) {
          td.classList.add('kb-over');
          td.setAttribute('data-limit', limitAttr);
        }
        if (YES.indexOf(lower) > -1 || NO.indexOf(lower) > -1) {
          td.innerHTML =
            '<span class="kb-chip' + (YES.indexOf(lower) > -1 ? ' kb-chip--yes' : '') + '">' + td.innerHTML + '</span>';
        }
      });
    });
    table.querySelectorAll('tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (cell, i) {
        if (numericCols[i]) cell.classList.add('kb-num');
      });
    });
  });
})();
